/**
 * useIsStandalone — true when the app is launched from a home-screen icon.
 * Covers both standard PWA (display-mode: standalone) and iOS Safari's
 * legacy `navigator.standalone` flag.
 */
import { useEffect, useState } from "react";

function readStandalone(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const mql = window.matchMedia?.("(display-mode: standalone)");
    if (mql?.matches) return true;
  } catch {/* noop */}
  // iOS Safari
  return !!(window.navigator as any).standalone;
}

export function useIsStandalone(): boolean {
  const [standalone, setStandalone] = useState<boolean>(() => readStandalone());

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia("(display-mode: standalone)");
    const onChange = () => setStandalone(readStandalone());
    try { mql.addEventListener("change", onChange); }
    catch { mql.addListener?.(onChange); }
    return () => {
      try { mql.removeEventListener("change", onChange); }
      catch { mql.removeListener?.(onChange); }
    };
  }, []);

  return standalone;
}
